import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "central_pharma_binder";

export const store = configureStore({
  reducer,
});
